// extracted by mini-css-extract-plugin
export default {"textInput":"ExternalLinksConfigContainer-textInput-bbb1607ca400ce9673c4f8e4e86c907b"};